import * as Sentry from "@sentry/nextjs";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React from "react";

import { PostWriterAvatarSize } from "@/consts/avatarSizes";
import { postDetailPageTranslations } from "@/consts/pageTranslationNamespace";
import { PostDetail } from "@/features/post/components/postDetail/PostDetail";
import { PostDocument } from "@/generated/generated-hooks";
import { convertWhitespaceToPlusInSlug } from "@/helpers/common/convertWhitespaceToPlusInSlug";
import { getServerSidePropswithApollo } from "@/server/graphql/apollo";
import { getLogger } from "@/services/datadog/serverLogger";

const logger = getLogger("ssr.post");

/* Related to fetchMore logic */
export default function PostPage() {
  return <PostDetail />;
}

export const getServerSideProps = getServerSidePropswithApollo(
  async ({
    params,
    locale,
    apolloClient /* apollo client is injected here */,
  }) => {
    const slug = convertWhitespaceToPlusInSlug(params?.slug as string);

    const translationProps = await serverSideTranslations(
      locale,
      postDetailPageTranslations,
    );

    try {
      const data = await apolloClient.query({
        query: PostDocument,
        variables: {
          slug,
          avatarSize: {
            maxWidth: PostWriterAvatarSize.MaxWidth,
            maxHeight: PostWriterAvatarSize.MaxHeight,
          },
          isEdit: false,
        },
      });

      if (!data.data.post)
        return {
          props: { ...translationProps },
          notFound: true,
        };
    } catch (error) {
      logger.error("ssr.post.error", { error, slug });

      Sentry.captureException(error, {
        tags: { ssr: "post" },
        extra: { slug },
      });

      return {
        props: { ...translationProps },
        notFound: true,
      };
    }

    return {
      props: { ...translationProps },
    };
  },
);
